import imageReducer, { imageInitState } from './imageReducer';
import serviceReducer, { serviceInitState } from './serviceReducer';
import validatorReducer from './validatorReducer';
import previewReducer, { previewInitState } from './previewReducer';
import canvasReducer, { canvasInitState } from './canvasReducer';

import { combineReducers } from 'redux';
import popupReducer from './popupReducer';

const rootReducer = combineReducers({
    imageReducer: imageReducer,
    canvasReducer: canvasReducer,
    previewReducer: previewReducer,
    validatorReducer: validatorReducer,
    serviceReducer: serviceReducer,
    popupReducer: popupReducer,
});

export type RootState = ReturnType<typeof rootReducer>

export default rootReducer;

export const initState = { imageReducer: imageInitState, serviceReducer: serviceInitState, canvasReducer: canvasInitState, previewReducer: previewInitState };